import { Link } from 'react-router-dom';
import { publicEvents } from '@/i18n/dictionaries/publicEvents';
import { useTranslation } from '@/i18n/useTranslation';
import { eventPath } from '@/features/publicsite/eventPath';
import { EVENT_KIND_LABEL } from '@/features/publicsite/events/eventKind';
import { eventTextLang } from '@/features/publicsite/events/eventLanguage';
import { EventMarkerBadge } from '@/features/publicsite/events/EventMarkerBadge';
import { PUBLIC_EVENT_STATUS } from '@/features/publicsite/events/eventStatus';
import { calendarLocale } from '@/features/publicsite/monthCalendar';
import type { EventCalendarItemProps } from '@/features/publicsite/types/events/EventCalendarItemProps';

/** One event on the /evenimente calendar: its date box, then kind, title, date and place. */
export function EventCalendarItem({ event: e }: EventCalendarItemProps) {
  const { t, language } = useTranslation(publicEvents);
  const d = new Date(e.startsAt);
  return (
    <Link className="cal-item" to={eventPath(e)}>
      <span className="cal-item__date">
        <strong>{String(d.getDate()).padStart(2, '0')}</strong>
        <span>{d.toLocaleDateString(calendarLocale(language), { month: 'short' })}</span>
      </span>
      <span className="cal-item__main">
        {/* Plain text, not a coloured pill: the label already reads as a category
          by being the line above the title, the way /instruiri's now does — the
          chip was decoration standing in for a distinction the position already
          makes. */}
        <span className="cal-item__cat">
          {t(EVENT_KIND_LABEL[e.kind])}
          {e.status === PUBLIC_EVENT_STATUS.archived && ` · ${t('mediaArchiveTag')}`}
        </span>
        <span className="cal-item__title" lang={eventTextLang(e, 'title', language)}>
          {e.title}
        </span>
        <span className="cal-item__meta">
          <span>
            {d.toLocaleDateString(calendarLocale(language), {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })}
          </span>
          {e.location && <span lang={eventTextLang(e, 'location', language)}>{e.location}</span>}
        </span>
        <EventMarkerBadge event={e} className="cal-item__state" />
      </span>
    </Link>
  );
}
